import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IncidentCard from '@ui/components/IncidentCard';
import SectionHeader from '../../components/SectionHeader';
import useHistoryStyles from './useHistoryStyles';
import { useTranslation } from 'react-i18next';
import incidentsApi from '@application/api/endpoints/incident-api';
import { toast } from 'react-toastify';
import { SearchInput } from '@ui/components/common';
import useHeaderStyles from '@ui/layout/Layout/components/Header/useHeaderStyles';
const buttonSortOptions = [
    { label: 'Newest - Oldest', value: 'dateNewestOldest', category: 'Date' },
    { label: 'Oldest - Newest', value: 'dateOldestNewest', category: 'Date' },
    { label: 'High - Low', value: 'scoreHighLow', category: 'Score' },
    { label: 'Low - High', value: 'scoreLowHigh', category: 'Score' }
];
const History = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    const { containerStyles, contentContainerStyles } = useHistoryStyles();
    const [selectedSortOption, setSelectedSortOption] = useState('dateNewestOldest');
    const [sortValue, setSortValue] = useState('dateNewestOldest');
    const [incidentData, setIncidentData] = useState(null);
    const [filteredIncidents, setFilteredIncidents] = useState([]);
    const { MobileHeaderContainer, SearchBarContainer, NavTitleContainer, NavInner } = useHeaderStyles();
    const [filterValues, setFilterValues] = useState({
        minScore: 1,
        maxScore: 100,
        searchText: null,
        // startDate: null,
        // endDate: null,
        location: null
    });
    useEffect(() => {
        if (!incidentData)
            return;
        if (filterValues?.searchText?.trim() === '') {
            setFilteredIncidents(incidentData);
        }
        else {
            var searchIncidents = incidentData?.filter((x) => x.licensePlate.toLowerCase().includes(filterValues?.searchText?.toLowerCase() || ''));
            setFilteredIncidents(searchIncidents);
        }
    }, [filterValues.searchText, incidentData]);
    const FetchIncidents = async () => {
        try {
            var response = await incidentsApi.fetchIncidnets(filterValues);
            if (response.isSuccess) {
                setIncidentData(response.data);
            }
        }
        catch (error) {
            toast.error(t('SomethingWentWrong'));
        }
        finally {
        }
    };
    const RefreshIncidents = async () => {
        try {
            const initialFilterValues = {
                minScore: 1,
                maxScore: 100,
                searchText: null,
                location: null
            };
            var response = await incidentsApi.fetchIncidnets(initialFilterValues);
            if (response.isSuccess) {
                setIncidentData(response.data);
            }
        }
        catch (error) {
            toast.error(t('SomethingWentWrong'));
        }
        finally {
        }
    };
    useEffect(() => {
        FetchIncidents();
    }, []);
    useEffect(() => {
        const sortedIncidents = sortIncidents(incidentData || [], selectedSortOption);
        setIncidentData(sortedIncidents);
    }, [selectedSortOption]);
    const sortIncidents = (incidents, sortBy) => {
        const sorted = [...incidents];
        switch (sortBy) {
            case 'dateNewestOldest':
                return sorted.sort((a, b) => new Date(b.incidentDate).getTime() - new Date(a.incidentDate).getTime());
            case 'dateOldestNewest':
                return sorted.sort((a, b) => new Date(a.incidentDate).getTime() - new Date(b.incidentDate).getTime());
            case 'scoreHighLow':
                return sorted.sort((a, b) => b.score - a.score);
            case 'scoreLowHigh':
                return sorted.sort((a, b) => a.score - b.score);
            default:
                return sorted;
        }
    };
    const handleCardClick = (id, title) => {
        console.log('Card clicked with ID:', id, 'and title:', title);
        if (title === undefined || title === null || title.trim() === '') {
            title = 'manual';
        }
        navigate(`/incident-history/${id}/list/${title}`);
    };
    const handleChangeSearch = ({ target: { value } }) => {
        setFilterValues((curr) => ({ ...curr, searchText: value }));
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { sx: MobileHeaderContainer, className: 'mobile-nav-container', children: [_jsx(Box, { className: 'nav-inner', sx: NavInner, children: _jsx(Box, { sx: NavTitleContainer, className: 'nav-title', children: _jsx(Typography, { variant: 'h4', className: 'mobile-nav-title', color: isLightMode ? theme.palette.common.white : theme.palette.grey[900], children: "Incident History" }) }) }), _jsx(Box, { className: 'searchbar-container', sx: SearchBarContainer, children: _jsx(SearchInput, { value: filterValues.searchText, onChange: handleChangeSearch }) })] }), _jsxs(Container, { id: 'page-history', sx: containerStyles, children: [_jsx(SectionHeader, { title: 'Incident List', sortValue: sortValue, setSortValue: setSortValue, buttonSortOptions: buttonSortOptions, filterValues: filterValues, setFilterValues: setFilterValues, showLocationField: true, showRangeSlider: false, showScoreRangeSlider: true, onApplyFilters: FetchIncidents, setSelectedSortOption: setSelectedSortOption, resetFilter: RefreshIncidents }), _jsx(Box, { sx: contentContainerStyles, className: 'history-content-container', children: filteredIncidents?.map(({ id, location, incidentDate, incidentTime, licensePlate, imageUrl, score }) => (_jsx(IncidentCard, { title: licensePlate, date: incidentDate, incidents: filteredIncidents.filter((x) => x.licensePlate == licensePlate).length, time: incidentTime, Score: score, location: location, onCardClick: () => handleCardClick(id, licensePlate), image: imageUrl }, id))) })] })] }));
};
export default History;
